import React, { useState, FormEvent, ChangeEvent, FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';

import TransparentButton from '../../components/shared/transparent-button/transparent-button';
import FormInput from './sign-in-form/form-input';

import './sign-in.scss';
import { useStore } from '../../store/store-provider';
import { getPresenterLinkPath } from '../../utils/helpers/api-helpers';
import { observer } from 'mobx-react';
import Header from '../../components/header/header';
import { localStoragePageInfo } from '../../utils/services/local-storage-service';
import { getMixpanelService } from '../../utils/services/mixpanel-service-instance';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../constans/mixpanel-contants';
import { getDefaultRoutePathByPermissions } from '../../utils/helpers/features-routes-helpers';

const SignInPage: FunctionComponent<{ embedId: string }> = ({ embedId }): JSX.Element => {
  const [accessCode, setAccessCode] = useState('');

  const history = useHistory();
  const { envPath: presenterLink, urlPath } = getPresenterLinkPath();
  const { authStore, podiumInfoStore, permissionsStore } = useStore();
  const {
    presentationInfo: { presentationName, interfaceBrandingLogoUrl }} = podiumInfoStore;
  const { getStorageProperty } = localStoragePageInfo;
  const userId = getStorageProperty(embedId, 'knovioUserId');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setAccessCode(e.target.value.trim());
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    await authStore.presenterLogin(presenterLink, accessCode, userId);
    if (authStore.isGetPresentationInfoSuccess) {
      getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.SIGN_IN, MIXPANEL_EVENT_TYPES.CLICKED_ACCESS);
      const path = getDefaultRoutePathByPermissions(permissionsStore);
      history.push(`${urlPath}${path}`);
    }
  };

  return (
    <div className="sign-on-page">
      <Header
        presentationName={presentationName}
        interfaceBrandingLogoUrl={interfaceBrandingLogoUrl}
        urlPath={urlPath}
      />
      <div className="sign-on-page__wrapper">
        <h1>Sign In</h1>
        <form className="form-sign-on" onSubmit={handleSubmit}>
          <FormInput
            label="Access code"
            value={accessCode}
            onChange={handleChange}
            errorMessage={authStore.errorMessage}
            showErrorMessage={!!authStore.errorMessage}
            type="password"
            required
          />
          <TransparentButton customClasses="sign-in-btn">Sign In</TransparentButton>
        </form>
      </div>
    </div>
  );
};

export default observer(SignInPage);
